import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { FC } from 'react';

import { styles } from './styles';

import type { AgreementCheckboxProps } from './types';

export const AgreementCheckbox: FC<AgreementCheckboxProps> = ({
    content,
    value,
    onChange,
    name,
}) => (
    <FormGroup css={styles.wrapper}>
        <FormControlLabel
            control={
                <Checkbox
                    checked={value}
                    onChange={onChange}
                    css={styles.checkbox}
                    id={`${name}-checkbox`}
                />
            }
            label={content}
            css={styles.label}
        />
    </FormGroup>
);
